var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 200 200",
    fill: "none",
    className: "group-hover:scale-105 transition-transform duration-500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mechGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A2D5E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eyeGlow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -65 L0 -85",
    stroke: "#00F0FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 -55 L-30 -75",
    stroke: "#2563EB",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -55 L30 -75",
    stroke: "#2563EB",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50 -45 L-40 20 L0 60 L40 20 L50 -45 H-50 Z",
    fill: "#0A2D5E",
    stroke: "url(#mechGrad2)",
    strokeWidth: 6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -62,
    y: -35,
    width: 10,
    height: 30,
    rx: 2,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: -35,
    width: 10,
    height: 30,
    rx: 2,
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 -30 L-30 15 L0 45 L30 15 L35 -30 H-35 Z",
    fill: "#020617",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#eyeGlow2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28 -15 L-10 -15 L-10 -7 L-28 -7 Z",
    fill: "#00F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 -15 L28 -15 L28 -7 L10 -7 Z",
    fill: "#00F0FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 45 L0 60",
    stroke: "#00F0FF",
    strokeWidth: 2,
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f870b7780989296e7d77562a1e5b680.svg";
export { ForwardRef as ReactComponent };